import React from 'react';
import "../Figure.css"


function Figure26() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (30min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Blank EC20 </th>
              <td> 0.15 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Blank SpaC </th>
              <td> 0.1 mg/L </td>
              <td> 0 mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
              <th> Water </th>
              <td> 1.41 mg/L </td>
              <td> - mg/L </td>
              <td> - mg/L </td>
            </tr> 
            <tr>
            <th> EC20 </th>
              <td> 0.5 mg/L </td>
              <td> 0.35 mg/L </td>
              <td> 1.06 mg/L </td>
            </tr>
            <tr> 
            <th> SpaC </th>
              <td> 0.65 mg/L </td>
              <td> 0.55 mg/L </td>
              <td> 0.86 mg/L </td>
            </tr> 
            <tr>
              <th className="colored-cell" colSpan="3"> Uptake difference </th>
              <th className="colored-cell"> 0.2 mg/L </th>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure26;